/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  MockNonfungiblePositionManager,
  MockNonfungiblePositionManagerInterface,
} from "../../../contracts/mock/MockNonfungiblePositionManager";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "__feeCollectionAmount",
        type: "uint256",
      },
    ],
    name: "_setFeeCollectionAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "__mockToken0",
        type: "address",
      },
    ],
    name: "_setMockToken0",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "__mockToken1",
        type: "address",
      },
    ],
    name: "_setMockToken1",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "amount0Max",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "amount1Max",
            type: "uint128",
          },
        ],
        internalType: "struct MockNonfungiblePositionManager.CollectParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "collect",
    outputs: [
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint128",
            name: "liquidity",
            type: "uint128",
          },
          {
            internalType: "uint256",
            name: "amount0Min",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "amount1Min",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
        ],
        internalType:
          "struct MockNonfungiblePositionManager.DecreaseLiquidityParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "decreaseLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token0",
            type: "address",
          },
          {
            internalType: "address",
            name: "token1",
            type: "address",
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24",
          },
          {
            internalType: "int24",
            name: "tickLower",
            type: "int24",
          },
          {
            internalType: "int24",
            name: "tickUpper",
            type: "int24",
          },
          {
            internalType: "uint256",
            name: "amount0Desired",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "amount1Desired",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "amount0Min",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "amount1Min",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
        ],
        internalType: "struct MockNonfungiblePositionManager.MintParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint128",
        name: "liquidity",
        type: "uint128",
      },
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type MockNonfungiblePositionManagerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MockNonfungiblePositionManagerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MockNonfungiblePositionManager__factory extends ContractFactory {
  constructor(...args: MockNonfungiblePositionManagerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<MockNonfungiblePositionManager> {
    return super.deploy(
      overrides || {}
    ) as Promise<MockNonfungiblePositionManager>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): MockNonfungiblePositionManager {
    return super.attach(address) as MockNonfungiblePositionManager;
  }
  override connect(signer: Signer): MockNonfungiblePositionManager__factory {
    return super.connect(signer) as MockNonfungiblePositionManager__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockNonfungiblePositionManagerInterface {
    return new utils.Interface(_abi) as MockNonfungiblePositionManagerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockNonfungiblePositionManager {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as MockNonfungiblePositionManager;
  }
}
